import { pxToRem } from '@/shared/styles/themes'
import { styled } from '@mui/material'

export const StyledFileInputWrapper = styled('div') <{
  $isDragActive?: boolean
  $error?: boolean
  $disabled?: boolean
}>`
  position: relative;
  width: calc(100% - ${pxToRem(36)});
  border-radius: ${pxToRem(4)};
  border: 2px dashed ${({ theme, $isDragActive, $error }) => {
    if ($error) return theme.palette.error.main
    if ($isDragActive) return theme.palette.primary.main

    return theme.palette.divider
  }};
  opacity: ${({ $disabled }) => $disabled ? 0.5 : 1};
  transition: all 0.2s ease-in-out;
  padding: ${pxToRem(16)};
`

export const StyledDropOverlay = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.custom.widgetDropTarget.backgroundColor};
  border-radius: ${pxToRem(4)};
`

export const StyledActions = styled('div')`
  display: flex;
  gap: ${pxToRem(8)};
`
